import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { FootieBall } from "./FootieIcon";
import { useFb } from "../../utils/football";
import { useAuth } from "../../contexts/AuthContext";
import { MINICUP_PUBLIC } from "../../utils/minicup";

// 56px promo strip shown above football page content (not on the game itself).
export default function MiniCupBanner() {
  const fb = useFb();
  const navigate = useNavigate();
  const { dbUser } = useAuth();
  const [sponsor, setSponsor] = useState(null);

  const isAdmin = !!dbUser?.is_admin;
  const hidden = !MINICUP_PUBLIC && !isAdmin;

  useEffect(() => {
    if (hidden) return;
    let active = true;
    (async () => {
      try { const d = await fb.get("/football/mini-cup/sponsor"); if (active) setSponsor(d.sponsor || null); } catch {}
    })();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hidden]);

  if (hidden) return null;

  const go = async () => {
    if (sponsor) { try { await fb.post("/football/mini-cup/sponsor/click", { surface: "banner" }); } catch {} }
    navigate("/football/mini-cup");
  };

  const bg = sponsor?.brand_color
    ? { background: `linear-gradient(90deg, ${sponsor.brand_color}, ${sponsor.brand_color}cc)` }
    : { background: "linear-gradient(90deg, #0b1f3a, #b8860b)" };
  const text = sponsor ? (sponsor.banner_text || `Powered by ${sponsor.sponsor_name}`) : "Play APL Penalty Cup";

  return (
    <button
      onClick={go}
      data-testid="minicup-banner"
      className="mb-3 flex h-14 w-full items-center gap-3 overflow-hidden rounded-xl border border-amber-400/30 px-3 text-left"
      style={bg}
    >
      <span className="minicup-pulse grid h-8 w-8 shrink-0 place-items-center overflow-hidden rounded-full bg-black/25">
        {sponsor?.logo_url ? (
          <img src={sponsor.logo_url} alt="" className="h-7 max-w-7 object-contain"
            onError={(e) => { e.currentTarget.style.display = "none"; }} />
        ) : (
          <FootieBall size={22} />
        )}
      </span>
      <span className="flex-1 truncate text-sm font-extrabold text-white">{text}</span>
      <span className="flex shrink-0 items-center gap-1 rounded-full wc-bg-gold px-3 py-1.5 text-xs font-extrabold text-slate-900">
        Play <ChevronRight size={14} />
      </span>
    </button>
  );
}
